(function(){
  var root=document.querySelector('.na'); if(!root) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('na-js');
  if(!('IntersectionObserver' in window)||reduce){document.querySelectorAll('.na-rv,.na-method,.na-steps').forEach(function(e){e.classList.add('is-in')});}
  else{
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');count(e.target);io.unobserve(e.target);}})},{rootMargin:'0px 0px -12% 0px'});
    document.querySelectorAll('.na-rv,.na-method,.na-steps').forEach(function(e){io.observe(e)});
  }
  function count(el){
    el.querySelectorAll('[data-count]').forEach(function(n){
      var to=+n.dataset.count,t0=null,suf=n.dataset.suffix||'';
      if(reduce){n.textContent=to+suf;return}
      function step(t){t0=t0||t;var p=Math.min((t-t0)/1400,1);n.textContent=Math.round(to*(1-Math.pow(1-p,3)))+suf;if(p<1)requestAnimationFrame(step)}
      requestAnimationFrame(step);
    });
  }
  // active tab
  var tabs=[].slice.call(document.querySelectorAll('.na-tabs a'));
  if(tabs.length&&'IntersectionObserver' in window){
    var so=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){tabs.forEach(function(a){a.classList.toggle('is-on',a.getAttribute('href')==='#'+e.target.id)})}})},{rootMargin:'-45% 0px -50% 0px'});
    tabs.forEach(function(a){var s=document.querySelector(a.getAttribute('href'));if(s)so.observe(s)});
  }
  // compass follows pointer a little
  var c=document.querySelector('.na-compass'); if(c&&!reduce&&window.matchMedia('(pointer:fine)').matches){
    var h=document.querySelector('.na-hero');
    h.addEventListener('pointermove',function(e){var r=h.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;c.style.transform='perspective(900px) rotateY('+(x*10)+'deg) rotateX('+(-y*10)+'deg)'});
    h.addEventListener('pointerleave',function(){c.style.transform=''});
    c.style.transition='transform .6s cubic-bezier(.2,.8,.2,1)';
  }
})();
(function(){
  // curvas de nivel generadas en el navegador (mapa topográfico)
  function rnd(seed){return function(){seed=(seed*16807)%2147483647;return (seed-1)/2147483646}}
  document.querySelectorAll('svg[data-topo]').forEach(function(svg){
    var a=svg.getAttribute('data-topo').split(',').map(Number),seed=a[0],cx=a[1],cy=a[2],n=a[3],step=a[4],amp=a[5],hi=a[6],wrap=a[7];
    var r=rnd(seed*9301+49297),ks=[2,3,4,5,7],ph=ks.map(function(){return r()*6.28}),am=ks.map(function(){return .3+r()*.7});
    var out='';
    for(var i=1;i<=n;i++){
      var r0=i*step,d='';
      for(var j=0;j<=48;j++){
        var t=j/48*Math.PI*2,s=0;
        for(var k=0;k<5;k++)s+=am[k]*Math.sin(ks[k]*t+ph[k]+i*.07)/ks[k];
        var rr=r0*(1+amp*s);
        d+=(j?'L':'M')+Math.round(cx+rr*Math.cos(t))+' '+Math.round(cy+rr*Math.sin(t)*.8);
      }
      out+='<path'+(i===hi?' class="hi"':'')+' d="'+d+'Z"/>';
    }
    svg.innerHTML=wrap?'<g>'+out+'</g>':out;
  });
})();
